// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3m-0";
export var eligibilityCardNotEligible = "_3m-1";